import { render, staticRenderFns } from "./XszzList.vue?vue&type=template&id=788a7098&scoped=true"
import script from "./XszzList.vue?vue&type=script&lang=js"
export * from "./XszzList.vue?vue&type=script&lang=js"
import style0 from "./XszzList.vue?vue&type=style&index=0&id=788a7098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a7098",
  null
  
)

export default component.exports